<template>
  <div>
      <!-- 操作 -->
      <Button type="success" style="margin: 20px 0 0;" @click="add">新增</Button>

      <!-- 查询条件 -->
      <Form ref="queryForm" :model="query" :label-width="80" inline>
        <FormItem label="名称" prop="name">
          <Input v-model="query.name" placeholder="请输入名称..." style="width:160px"></Input>
        </FormItem>
        <FormItem label="">
          <Button type="primary" style="margin-bottom: 6px; margin-left: 6px;" icon="ios-search" @click="search">查询</Button>
        </FormItem>
      </Form>

      <!-- 表格&分页 -->
      <Table border :columns="columns" :data="data"/>

      <!-- 编辑&查看 modal -->
      <Modal
        v-model="showModal"
        :mask-closable="false"
        :title="isEdit?'编辑':'查看'">
        <div slot="footer">
            <Button v-if="isEdit" size="large" @click="showModal=false">取消</Button>
            <Button v-if="isEdit" type="primary" size="large" :loading="modalLoading" @click="handleModify">确定</Button>
            <Button v-else type="primary" size="large" :loading="modalLoading" @click="showModal=false">确定</Button>
        </div>
        <RolesPopForm ref="popForm" :is-edit="isEdit" :data="currentData" :visible="showModal"></RolesPopForm>
      </Modal>

      <!-- 新增 modal -->
      <Modal
        v-model="showAddModal"
        title="新增角色"
        :mask-closable="false"
        :loading="addModalLoading"
        @on-ok="handleAdd">
        <Form ref="addForm" :model="addForm" :label-width="80">
          <FormItem label="名称">
            <Input v-model="addForm.name" placeholder="请输入名称..."></Input>
          </FormItem>
          <FormItem label="描述">
            <textarea v-model="addForm.description" placeholder="请输入描述..." style="width: 100%;"></textarea>
          </FormItem>
        </Form>
      </Modal>
    </div>
</template>

<script>
import { AuthItemsService } from '@/services/resources'
import RolesPopForm from '@/components/views/RolesPopForm'
import { AuthItemType } from '@/services/const'

export default {
  name: 'roles',
  components: {
    RolesPopForm
  },
  data () {
    return {
      columns: [
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '描述',
          key: 'description'
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return (
              <div>
                <a style={{ marginRight: '10px' }} onClick={() => this.show(params.index)}>查看</a>
                <a style={{ marginRight: '10px' }} onClick={() => this.update(params.index)}>编辑</a>
                <a style={{ marginRight: '10px' }} onClick={() => this.assignPermission(params.index)}>分配权限</a>
              </div>
            )
          }
        }
      ],
      // 表格数据
      data: [],
      // 当前操作记录索引
      currentIndex: 0,
      // 编辑&查看
      showModal: false,
      modalLoading: false,
      isEdit: false,
      // 新增
      showAddModal: false,
      addModalLoading: true,
      addForm: {},
      query: {}
    }
  },
  computed: {
    currentData () {
      let data = { ...this.data[this.currentIndex] }
      data.id = data.name
      return data
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      let params = Object.assign({}, { type: AuthItemType.Role }, this.query)
      let resp = await AuthItemsService.query(params)
      this.data = resp.data
    },
    async handleModify () {
      this.modalLoading = true
      try {
        await this.$refs.popForm.formSubmit()
        this.$Message.success('更新成功')
        this.showModal = false
        this.modalLoading = false
        this.loadData()
      } catch (e) {
        this.modalLoading = false
        throw new Error(e)
      }
    },
    handleAdd () {
      this.addForm.type = AuthItemType.Role
      AuthItemsService.create(this.addForm).then(resp => {
        this.$Message.success('添加成功')
        this.showAddModal = false
        this.loadData()
      })
    },
    update (index) {
      this.isEdit = true
      this.showModal = true
      this.currentIndex = index
    },
    assignPermission (index) {
      this.$router.push({
        name: 'rolePermission',
        params: {
          id: this.data[index].name
        }
      })
    },
    show (index) {
      this.isEdit = false
      this.showModal = true
      this.currentIndex = index
    },
    add () {
      this.showAddModal = true
    },
    search () {
      this.loadData()
    },
    handleTypeClick (item) {
      this.query.category_id = item.category_id
      this.loadData()
    }
  },
  watch: {
    showAddModal (nVal) {
      if (nVal) this.addForm = {}
    }
  }
}
</script>
